module.exports = __webpack_public_path__ + "static/media/preventTeenSuicide.fc801b5a.jpg";